import { Component, inject, viewChild } from '@angular/core';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ProjectFacade } from '@mitsubishi/project/data-access';
import { ButtonComponent, SectionTitleComponent } from '@mitsubishi/shared/ui';

import { FreeStUtils } from '../../chiller-free-st.utils';
import { ChillerFreeStConfigurationFiltersComponent } from '../../components/chiller-free-st-configuration-filters/chiller-free-st-configuration-filters.component';
import { ChillerFreeStConfigurationResultsComponent } from '../../components/chiller-free-st-configuration-results/chiller-free-st-configuration-results.component';
import { ChillerFreeStStore } from '../../stores/chiller-free-st.store';

@Component({
  selector: 'apm-chiller-free-st-configuration',
  imports: [
    ChillerFreeStConfigurationFiltersComponent,
    ChillerFreeStConfigurationResultsComponent,
    SectionTitleComponent,
    ApmTranslatePipe,
    ButtonComponent,
  ],
  providers: [ChillerFreeStStore],
  templateUrl: './chiller-free-st-configuration.component.html',
  styleUrl: './chiller-free-st-configuration.component.scss',
})
export class ChillerFreeStConfigurationComponent {
  #projectFacade = inject(ProjectFacade);
  readonly store = inject(ChillerFreeStStore);

  readonly filters = viewChild.required(ChillerFreeStConfigurationFiltersComponent);

  projectName = this.#projectFacade.activeProjectDetailsSnapshot.title;
  projectNotes = this.#projectFacade.activeProjectDetailsSnapshot.note;

  constructor() {
    this.store.loadStart();
  }

  confirmComponents(): void {
    const formValues = this.filters().form.getRawValue();
    const request = FreeStUtils.buildCombRequest(formValues, this.projectName, this.projectNotes);
    this.store.loadCombinations(request);
  }
}
